// Dashboard page components
import { defineAsyncComponent } from 'vue'

export default {
  DashboardIndex: defineAsyncComponent(() => import('../dashboard/index.vue')),
  DashboardPowerPlantList: defineAsyncComponent(
    () => import('../dashboard/power_plant_list.vue')
  ),
  PowerPlantWindyMap: defineAsyncComponent(
    () => import('../dashboard/power_plant_windy_map.vue')
  ),
  KioskModeIndex: defineAsyncComponent(() => import('../kiosk_mode/index.vue'))
}
